import { PayloadAction, createSelector } from '@reduxjs/toolkit';
import { ReportsReducerState } from './types';
import { RootState } from '../../../../store';
import { createExtendedSlice } from 'src/store/createExtendedSlice';
import { LogMsgFailed } from 'src/app/store/routingSlice/types';
import { initialState } from './utils';

const sliceName = 'ReportsView';

// =============================
// ------- Slice ----------
// =============================
export const reportsViewSlice = createExtendedSlice({
  name: sliceName,
  initialState,
  reducers: {
    // ---- Internal ---
    reportsViewInit: (state) => {},
    reportsViewFetchDashboardRequest: (state) => {},
    reportsViewFetchDashboardSuccess: (
      state,
      { payload }: PayloadAction<ReportsReducerState['data']>,
    ) => {
      state.data = payload;
    },
    reportsViewFetchDashboardFailed: (
      state,
      { payload }: PayloadAction<LogMsgFailed>,
    ) => {},
    reportsViewResetControlFilters: (state) => {
      // state.filters.controls = initialState.filters.controls;
    },
    reportsViewSetControlFilters: (
      state,
      // { payload }: PayloadAction<ReceiptsReducerState['filters']['controls']>,
    ) => {
      // state.filters.controls = payload;
    },
  },
});

// =============================
// ------- selectors ----------
// =============================
export const getReportsViewFiltersData = (state: RootState) =>
  state.reportsView.filters;

export const getReportsViewData = (state: RootState) => state.reportsView.data;

export const getReportsViewDataReports = createSelector(
  getReportsViewData,
  (data) => data?.reports,
);

// =============================
// ------- Exports ----------
// =============================

export const {
  reportsViewInit,
  reportsViewFetchDashboardRequest,
  reportsViewFetchDashboardSuccess,
  reportsViewFetchDashboardFailed,
  reportsViewResetControlFilters,
  reportsViewSetControlFilters,
} = reportsViewSlice.actions;

export default reportsViewSlice.reducer;
